import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=717ff96b&"
import script from "./Sort.vue?vue&type=script&lang=js&"
export * from "./Sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('717ff96b')) {
      api.createRecord('717ff96b', component.options)
    } else {
      api.reload('717ff96b', component.options)
    }
    module.hot.accept("./Sort.vue?vue&type=template&id=717ff96b&", function () {
      api.rerender('717ff96b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/parametric/Sort/Sort.vue"
export default component.exports